var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.80206 0 0 3.80163 0 8.5C0 13.1979 3.80163 17 8.5 17C13.1979 17 17 13.1984 17 8.5C17 3.80212 13.1984 0 8.5 0ZM8.5 15.814C4.46708 15.814 1.18605 12.533 1.18605 8.5C1.18605 4.46705 4.46708 1.18605 8.5 1.18605C12.5329 1.18605 15.814 4.46705 15.814 8.5C15.814 12.533 12.5329 15.814 8.5 15.814Z",
    fill: "#49712B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50019 7.08594C7.9967 7.08594 7.63867 7.29857 7.63867 7.61184V11.8747C7.63867 12.1432 7.9967 12.4117 8.50019 12.4117C8.98131 12.4117 9.37287 12.1432 9.37287 11.8747V7.61178C9.37287 7.29854 8.98131 7.08594 8.50019 7.08594Z",
    fill: "#49712B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50044 4.45703C7.98576 4.45703 7.58301 4.82625 7.58301 5.25142C7.58301 5.67662 7.9858 6.05702 8.50044 6.05702C9.00394 6.05702 9.40676 5.67662 9.40676 5.25142C9.40676 4.82625 9.0039 4.45703 8.50044 4.45703Z",
    fill: "#49712B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.fbd5123838971921d8292f85453c1c40.svg";
export { ForwardRef as ReactComponent };